const state = {
  eventStatuses: {
    toDo: { label: 'A venir', position: 1 },
    inProgress: { label: 'En cours', position: 2 },
    done: { label: 'Terminé', position: 3 }
  },
  actionStatuses: {
    toDo: { label: 'A venir', position: 1 },
    requested: { label: 'Demandé', position: 2 },
    inProgress: { label: 'En cours', position: 3 },
    done: { label: 'Terminé', position: 4 }
  },
  statuses: null,
  statusColors: {
    requested: { color: '#F58320' },
    toDo: { color: '#FF4757' },
    inProgress: { color: '#0059FF' },
    done: { color: '#1EB38B' }
  }
}

const getters = {
  getEventStatusTranslation (state) {
    return status => state.eventStatuses[status].label
  },
  getActionStatusTranslation (state) {
    return status => state.actionStatuses[status].label
  },
  findStatuses (state) {
    return state.statuses
  },
  getAllEventStatuses (state) {
    return Object.entries(state.eventStatuses).map(status => {
      return { id: status[0], label: status[1].label, disable: false, color: state.statusColors[status[0]].color }
    })
  },
  getAllActionStatuses (state) {
    return Object.entries(state.actionStatuses).map(status => {
      return { id: status[0], label: status[1].label, disable: false, color: state.statusColors[status[0]].color }
    })
  }
}

const mutations = {
  findStatuses (state, { entityName, currentStatus }) {
    let statuses = null

    switch (entityName) {
      case 'event':
        statuses = state.eventStatuses
        break
      case 'action':
        statuses = state.actionStatuses
        break
      default:
        statuses = state.eventStatuses
        break
    }
    state.statuses = Object.entries(statuses).map(status => {
      if (currentStatus) {
        return {
          id: status[0],
          label: status[1].label,
          disable: status[1].position < statuses[currentStatus].position
        }
      }

      return { id: status[0], label: status[1].label, disable: false, color: state.statusColors[status[0]].color }
    })
  }
}

const actions = {
  findStatuses (context, params) {
    context.commit('findStatuses', { entityName: params.entityName, currentStatus: params.currentStatus })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
